/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Digest } from '../models/Digest';
import type { DigestInput } from '../models/DigestInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DigestsService {
    /**
     * Получить список дайджестов
     * @returns any Список дайджестов
     * @throws ApiError
     */
    public static getDigests(): CancelablePromise<{
        items?: Array<Digest>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digests',
        });
    }
    /**
     * Создать новый дайджест
     * @param requestBody
     * @returns Digest Дайджест успешно создан
     * @throws ApiError
     */
    public static createDigest(
        requestBody: DigestInput,
    ): CancelablePromise<Digest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digests',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получить дайджест по ID
     * @param id ID дайджеста
     * @returns Digest Дайджест найден
     * @throws ApiError
     */
    public static getDigest(
        id: string,
    ): CancelablePromise<Digest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digests/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Дайджест не найден`,
            },
        });
    }
    /**
     * Обновить дайджест по ID
     * @param id ID дайджеста
     * @param requestBody
     * @returns Digest Дайджест обновлён
     * @throws ApiError
     */
    public static updateDigest(
        id: string,
        requestBody: DigestInput,
    ): CancelablePromise<Digest> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/digests/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Дайджест не найден`,
            },
        });
    }
    /**
     * Удалить дайджест по ID
     * @param id ID дайджеста
     * @returns void
     * @throws ApiError
     */
    public static deleteDigest(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/digests/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Дайджест не найден`,
            },
        });
    }
}
